<app-call-to-action [title]="'Ready to launch your nonprofit’s auction?'"
  [body]="'Over 20,000 schools and charities have raised $600M (and counting!) through the BiddingForGood community’s online auctions.'"
  [ctaLabel]="'Learn how'"
  [href]="'https://www.frontstream.com/request-a-demo-biddingforgood?utm_source=BFG&utm_campaign=bfg-request-a-demo&utm_medium'"
  [target]="'_self'" [imageSrc]="'/Top-Image.jpg'" [badgeImageSrc]="'/Oval.png'" [showBadge]="true"
  [bgColor]="'#FFFFFF'" [borderColor]="'#FFFFF'" [hasBorder]="true">
</app-call-to-action>

<div #goodometercontainer class="grid w-full md:px-[3.5rem] md:p-7">
  <app-main-goodmeter></app-main-goodmeter>
</div>

@defer (on viewport(goodometercontainer)) {
<app-featured-auctions></app-featured-auctions>
} @placeholder {
<div class="flex items-center justify-center min-h-[300px]">
  <p-progress-spinner ariaLabel="loading featured auctions" />
</div>
}

@defer (on viewport(goodometercontainer)) {
<div class="w-full md:px-[3.5rem] pt-8">
  <app-featured-items></app-featured-items>
</div>
} @placeholder {
<div class="flex items-center justify-center min-h-[300px]">
  <p-progress-spinner ariaLabel="loading featured items" />
</div>
}

<app-item-categories></app-item-categories>

<div class="w-full relative z-20 md:mb-[-100px]">
  <app-call-to-action class=" relative -translate-y-[10%] md:-translate-y-[12%] shadow-xl"
    [title]="'Raise More with BiddingForGood Auctions'" [title]="'Raise More with BiddingForGood Auctions'"
    [bodyHtml]="'Nonprofits that open their fundraisers to the BiddingForGood Community <strong>raise 27% more</strong> on average.'"
    [ctaLabel]="'Get a Product Tour'"
    [href]="'https://www.frontstream.com/request-a-demo-biddingforgood?utm_source=BFG&utm_campaign=bfg-request-a-demo&utm_medium'"
    [target]="'_self'" [imageSrc]="'/Bottom-Image.jpg'" [badgeImageSrc]="''" [showBadge]="false" [showRating]="true"
    [rating]="4.7" [reviewCount]="115" [bgColor]="'#DFF3EA'" [hasBorder]="false" [flat]="true" [isRaiseMore]="true">
  </app-call-to-action>
</div>